import http from './http'

export default class DeputyNavApi {
	// 获取产品/文章页面
	static getDetailPageList(params) {
		return http.httpGet('/lavrock/edit/navprod', params)
	}
	/**
	 * 添加列表页面
	 * @param {projId, pageId, navType = 2} params
	 */
	static addDeputyNavPage(params) {
		return http.httpPut('/lavrock/page/pagecopy', null, params)
	}
	/**
	 *
	 * @param {*} data
	//  * @param {projId, pageId, pageSize}params
	 */
	static deputyPageImport(data) {
		return http.httpPost('/lavrock/edit/prodlist', data)
	}
	/**
	 *
	 * @param {"projId": "22210","menuId": "菜单编号：当前操作页面编号", "pageId": "页面编号，当前产品连接页编号", "prodImg": "图片url", "topOrder": "置顶-1", "pageSize": "设置置顶时必须传入页面数量" } data
	 */
	static updateDeputyPage(data) {
		return http.httpPut('/lavrock/edit/navprod', data)
	}
	/**
	 * 获取分类所关联的页面
	 * @param {menuId} params
	 */
	static getDeputyImpPage(params) {
		return http.httpGet('/lavrock/edit/navprodrel', params)
	}
	/**
	 * 设置外链
	 * @param {Object} params
	 */
	static setDeputyOuterLink(params) {
		return http.httpGet('/lavrock/page/outerLinkUpdate', params)
	}
}
